import { ComunidadContent } from "./comunidad/ComunidadContent";

export const ComunidadTab = () => {
  return <ComunidadContent />;
};
